// after that period referrer removed from localstore
export const REF_LIFETIME = 31_536_000_000
export const REFERRAL_PREFIX = 'ref:'
